export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Request": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集荷依頼をする"])},
      "Cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集荷依頼をキャンセル"])}
    }
  })
}
